<template>
  <div class="dayreport">
    <div class="dayreportbox" v-for="(item, i) in data" :key="i">
      <div class="title">
        <i class="icon" />{{ item.time }} {{ type == "日报" ? "日报" : "周" }}
      </div>
      <div class="wire" />
      <div class="dayreportcont">
        今日督查任务<span class="blue">{{ item.total }}</span
        >个，其中已督查工地<span class="blue">{{ item.done }}</span
        >个，未督查工地{{ item.undone }}个，典型问题工地<span class="red">{{
          item.typical
        }}</span
        >个
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { APIMAP } from "@/constants/apiConstants";
import { getServerData } from "@/utils/fetchData";
export default {
  data() {
    return {
      type: "日报",
      data: [],
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {
    this.getlist();
  },
  methods: {
    async getlist() {
      try {
        const res = await getServerData(
          APIMAP.HOME + "/dispatchstatics",
          {
            pid: this.userInfo.platformid,
            eid: this.userInfo.eid,
            type: this.type == "日报" ? "DAY" : "WEEK",
          },
          "get"
        );
        console.log("典型问题汇报", res);
        this.data = res;
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.dayreport {
  .dayreportbox {
    width: calc(33.3% - 47px);
    border: 1px solid #f3f3f3;
    padding: 15px;
    margin-bottom: 15px;
    float: left;
    margin-right: 15px;
    overflow-x: hidden;
    height: 100px;
    .title {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 900;
      color: #2c3a50;
      letter-spacing: 2px;
      .icon {
        width: 3px;
        height: 13px;
        background: #009157;
        display: inline-block;
        margin-right: 10px;
      }
    }
    .wire {
      margin-top: 10px;
      border: 1px solid rgba(226, 229, 236, 0.6);
    }
    .dayreportcont {
      margin-top: 10px;
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Regular;
      color: #969aa5;
      line-height: 20px;
      letter-spacing: 1px;
      .blue {
        color: blue;
      }
      .red {
        color: red;
      }
    }
  }
}
</style>
